export default function prepareGreyNoiseConfig(config: Record<string, unknown>): Record<string, unknown> {
  const apiToken = config.api_token as { is_set?: boolean } | undefined;

  if (apiToken && 'is_set' in apiToken) {
    return {
      ...config,
      api_token: apiToken.is_set ? { keep_value: true } : { set_value: '' },
    };
  }

  return config;
}
